// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Input } from "@revvsales/components";

const ReviewerListSection = ({
  ownerId,
  sharedReviewers,
  removeAddedReviewer,
  showAndHideReviewerList,
  showList,
  updateEditPermission,
}) =>
  sharedReviewers && sharedReviewers.length > 0 ? (
    <div className="recipientlistsection-addedreviewerslist-wrapper">
      <div className="docsharingpopup-sharingform-title">
        Other people with access to this document &nbsp; &nbsp; &nbsp;
        <span
          className="documentrecipient-toggle-handle"
          onKeyPress={() => {}}
          role="button"
          tabIndex="0"
          onClick={() => showAndHideReviewerList()}>
          {showList ? "Show" : "Hide"}
        </span>
      </div>
      <div className="recipientlistsection-reviewerlist">
        {sharedReviewers.map(reviewer => (
          <div
            className={`
                      ${
                        showList
                          ? "documentrecipient-view-visiblity-hidden"
                          : ""
                      }
                    ${"recipientlistsection-row shared-reviewers-row"}`}>
            <div className="col-md-7 docsharingpopup-sharedusers-col shared-reviewers-namecol">
              <div className="documentrecipientlist-userprofile-wrapper">
                <div className="documentrecipientlist-profileimage-wrapper">
                  {reviewer.user.image_url && (
                    <img alt="Revv" src={reviewer.user.image_url} />
                  )}
                </div>
                <div className="documentrecipientlist-profile-wrapper">
                  <span className="documentrecipientlist-profile-name">
                    {reviewer.user &&
                    (reviewer.user.first_name ||
                      reviewer.user.reviewer.last_name)
                      ? `${reviewer.user.first_name} ${reviewer.user.last_name}`
                      : "-"}
                  </span>
                  {/* <span className="documentrecipientlist-role">
                    <span className="role-icon-mar">
                      {reviewer.user ? reviewer.user.user_email : "-"}
                    </span>
                  </span> */}
                  <span className="documentrecipientlist-profile-email">
                    {reviewer.user ? reviewer.user.user_email : "-"}
                  </span>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6 docsharingpopup-sharedusers-col documentrecipientlist-col shared-reviewers-col">
               <span className="documentrecipientlist-role">
                <span className="role-icon-mar">
                  {reviewer.user ? reviewer.user.user_email : "-"}
                </span>
              </span>
            </div> */}
            {reviewer.user.is_external ? (
              <div className="col-md-4 docsharingpopup-sharedusers-col documentrecipient-edit-col">
                <Tooltip
                  placement="top"
                  align={{
                    offset: [0, 4],
                  }}
                  overlay="You can't switch edit access for external sharing">
                  <span className="documentrecipientlist-role">
                    <Input
                      className="docsharingpopup-sharingform-col"
                      disabled={reviewer.user.is_external}
                      isSwitch
                      type="checkbox"
                      value=""
                      checked={
                        ownerId === reviewer.user.id
                          ? true
                          : reviewer.is_editable
                      }
                      onChange={() =>
                        updateEditPermission(
                          reviewer.user ? reviewer.user.id : null,
                        )
                      }
                      data-test="reviewerlistsection-checkbox-input"
                    />

                    <span className="documentrecipientlist-role">
                      can edit document
                    </span>
                    {/* <FontAwesomeIcon
                  icon={["far", "signature"]}
                  className="documentrecipientlist-role-icon"
                />
                <span className="role-icon-mar">Signer</span> */}
                  </span>
                </Tooltip>
              </div>
            ) : (
              <div className="col-md-4 docsharingpopup-sharedusers-col documentrecipient-edit-col">
                <span className="documentrecipientlist-role">
                  <Input
                    className="docsharingpopup-sharingform-col"
                    disabled={reviewer.user.is_external}
                    isSwitch
                    type="checkbox"
                    value=""
                    checked={
                      ownerId === reviewer.user.id ? true : reviewer.is_editable
                    }
                    onChange={() =>
                      updateEditPermission(
                        reviewer.user ? reviewer.user.id : null,
                      )
                    }
                    data-test="reviewerlistsection-edit-checkbox"
                  />

                  <span className="documentrecipientlist-role">
                    can edit document
                  </span>
                  {/* <FontAwesomeIcon
                  icon={["far", "signature"]}
                  className="documentrecipientlist-role-icon"
                />
                <span className="role-icon-mar">Signer</span> */}
                </span>
              </div>
            )}
            {ownerId !== reviewer.user.id ? (
              <div className="col-md-1 docsharingpopup-sharingform-col doc-recipients-delete-icon">
                <span
                  className="btn-icon"
                  onClick={() =>
                    removeAddedReviewer(reviewer.user ? reviewer.user.id : null)
                  }
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex="0">
                  <FontAwesomeIcon icon={["far", "trash-alt"]} />
                </span>
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  ) : null;

export default ReviewerListSection;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AddRecipientsPopup/ReviewerListSection.js